import React from 'react';
import PropTypes from 'prop-types';

const MenuLabel = ({ label, badgeText, badgeColor }) => {
    return (
        <span className="mr-1">
            {label}
            <span className={`badge bg-${badgeColor} text-white ml-2`} style={{marginLeft: '4px', padding: '2px 4px'}}>
                {badgeText}
            </span>
        </span>
    );
};

MenuLabel.propTypes = {
    label: PropTypes.string.isRequired,
    badgeText: PropTypes.string.isRequired,
    badgeColor: PropTypes.string
};

MenuLabel.defaultProps = {
    badgeColor: 'info'
};

export default MenuLabel;